import { tabletMax, mobileLargeMax, mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import WhiteModal from '../modal/WhiteModal';
import { CloseButton, Header } from '../modal/WhiteModal.style';
import { Heading, LinkText } from '../typography';

export const Container = styled.div`
  margin: 15px 0 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundLight};
`;

export const NoResultsContainer = styled.div`
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;

  @media (${tabletMax}) {
    flex-direction: column;
    align-items: flex-start;
  }

  ${LinkText}:hover {
    text-decoration: underline;
    color: initial;
  }
`;

export const NoResultsImg = styled.img`
  max-width: 100%;
`;

const actionStyles = css`
  font-size: 17px;
  user-select: none;
  font-weight: 600;
  transition:
    color 150ms linear,
    border-color 150ms linear;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  color: inherit;

  &:hover {
    color: ${({ theme }) => theme.backgroundMid};
  }
`;

export const AddPlaceContainer = styled.button<{ lg?: boolean }>`
  ${actionStyles}

  ${({ lg }) =>
    lg
      ? css`
          font-size: 20px;
          padding: 10px;
          border-radius: 5px;
          border: 1px solid ${({ theme }) => theme.keyline};
          margin-bottom: 20px;

          &:hover {
            border-color: ${({ theme }) => theme.backgroundMid};
          }
        `
      : ''}
`;

export const ManagePlaceContainer = styled(Link)`
  ${actionStyles}
`;

export const ResultsContainer = styled.div`
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.lightGrey};
  margin-bottom: 16px;
`;

export const PlaceList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Place = styled.li`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.lightGrey};
  }

  @media (max-width: 350px) {
    flex-direction: column;
  }
`;

export const PlaceIcon = styled.img`
  flex-grow: 0;
  flex-shrink: 0;
  width: 23px;
  height: 23px;
  margin-top: 4px;

  @media (min-width: 351px) {
    margin-right: 16px;
  }
`;

export const PlaceItem = styled.span`
  flex: 1 1 auto;
  font-weight: 700;
  font-size: 21px;
`;

export const PlaceTravel = styled.span`
  flex: 1 1 auto;
  text-align: right;

  @media (max-width: 350px) {
    text-align: center;
  }
`;

export const PlaceTime = styled.span<{ exceed: boolean }>`
  display: block;
  margin-bottom: 5px;

  ${({ exceed }) =>
    exceed
      ? css`
          color: #757575;
          font-size: 15px;
          font-style: italic;
        `
      : ''}
`;

export const ActionContainer = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  gap: 16px;

  @media (${mobileLargeMax}) {
    flex-direction: column;
  }
`;

export const CloseToModal = styled(WhiteModal)`
  @media (${mobileXLargeMax}) {
    ${Heading} {
      text-align: left;
      font-size: 20px;
    }

    ${Header} {
      padding-left: 12px;
      padding-right: 45px;
    }

    ${CloseButton} {
      top: 6px;
      svg {
        margin-left: 0 !important;
        font-size: 25px !important;
        height: 25px !important;
      }
    }
  }
`;
